import { Component, OnInit, Input } from '@angular/core';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { Subscription } from 'rxjs';
import { SegmentoService } from 'src/app/services/segmento.service';
import { CapaService } from 'src/app/services/capa.service';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take } from 'rxjs/operators';

@Component({
  selector: 'formato-pdf-ficha-tecnica-historico',
  templateUrl: './formato-pdf-ficha-tecnica-historico.component.html',
  styleUrls: ['./formato-pdf-ficha-tecnica-historico.component.scss']
})
export class FormatoPdfFichaTecnicaHistoricoComponent implements OnInit {

  @Input('obraSeleccionada')
  public obraSeleccionada: ObraDTO;

  public colores: ElementoCatalogo[] = [];
  public datosCoordenadas: any;
  public colorCapa: any;

  public fechaActual: any;
  public tipoCarpetaYSeccion: any;

  checked: boolean = false;
  checked2: boolean = true;
  public informacionCargada: boolean = false;

  public marker: any = {
    url: '../../../../../assets/img/iconos/marker-red.png',
    scaledSize: {
      width: 25,
      height: 25
    }
  };

  public catalogoColores: ElementoCatalogo[] = [];
  public catCorredores: ElementoCatalogo[] = [];
  public readonly KEY_COLOR_CAPA_PROYECTO_PROCESO: string = '0';
  public readonly KEY_COLOR_CAPA_PROYECTO_PLANEACION: string = '4';
  public HEX_COLOR_CAPA_PROYECTO_PROCESO: string = '';
  public HEX_COLOR_CAPA_PROYECTO_PLANEACION: string = '';
  public readonly CAPA_PROYECTO_PROCESO: string = 'Proceso';

  constructor(private catalogoService: CatalogoService) { }

  ngOnInit() { }

  public ngOnChanges(): void {
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const carpetas = ["Asfáltica", "Hidráulica", "Rodaderas"];
    const secciones = ["A1", "A2", "A3", "A4", "6M", "7M", "9M"]
    let fechaConvert: Date = new Date(this.obraSeleccionada.obra.fechaActualizacion);
    this.fechaActual = (fechaConvert.getUTCDate() + " de " + monthNames[fechaConvert.getUTCMonth()] + " de " + fechaConvert.getUTCFullYear());
    this.tipoCarpetaYSeccion = carpetas[this.obraSeleccionada.obra.keyCatCarpeta] + " - " + secciones[this.obraSeleccionada.obra.keyCatSeccion];
    this.obtenerCatalogos();
  }

  public async obtenerCatalogos() {
    this.catalogoColores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).toPromise();
    this.catCorredores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CORREDORES).pipe(take(1)).toPromise();
    this.informacionCargada = true;
  }

  public obtenerNombreCorredor(keyCorredor: string): string {
    return this.catCorredores.find((corredor: ElementoCatalogo) => corredor.key === keyCorredor).nombre;
  }

}
